import { Link } from 'react-router-dom';
import { articles, difficultyColors } from '@/mocks/articles';

const featuredData = [
  {
    ...articles[0],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20whimsical%20game%20scene%20with%20colorful%20mushrooms%20and%20a%20small%20adventurer%20in%20a%20fantasy%20forest%2C%20soft%20warm%20lighting%2C%20hand-drawn%20illustration%20style%2C%20bright%20colors%2C%20magical%20atmosphere%2C%20mushroom%20platforms%20at%20various%20heights%2C%20sparkles%20and%20fireflies%20floating%20around%2C%20golden%20hour%20sunlight%20through%20leaves%2C%20playful%20mood&width=600&height=400&seq=featured-article-01&orientation=landscape',
  },
  {
    ...articles[1],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20game%20level%20map%20with%20mushroom%20platforms%20and%20obstacles%20in%20a%20fantasy%20forest%2C%20hand-drawn%20illustration%20style%2C%20warm%20colors%2C%20adventure%20theme%2C%20floating%20islands%20with%20mushrooms%2C%20magical%20glowing%20pathways%2C%20soft%20golden%20lighting%2C%20storybook%20aesthetic&width=600&height=400&seq=featured-article-02&orientation=landscape',
  },
  {
    ...articles[2],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20golden%20trophy%20sitting%20on%20top%20of%20a%20giant%20red%20mushroom%20in%20a%20magical%20forest%2C%20sparkles%20around%20it%2C%20hand-drawn%20illustration%20style%2C%20celebratory%20atmosphere%2C%20warm%20sunlight%2C%20achievement%20and%20victory%20theme%2C%20bright%20cheerful%20colors%2C%20soft%20whimsical%20lighting&width=600&height=400&seq=featured-article-03&orientation=landscape',
  },
  {
    ...articles[3],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20ninja-like%20adventurer%20performing%20an%20acrobatic%20wall%20jump%20between%20two%20giant%20mushrooms%20in%20a%20fantasy%20forest%2C%20action%20pose%2C%20hand-drawn%20illustration%20style%2C%20dynamic%20composition%2C%20warm%20golden%20lighting%2C%20motion%20lines%2C%20adventurous%20mood&width=600&height=400&seq=featured-article-04&orientation=landscape',
  },
  {
    ...articles[4],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20hidden%20secret%20door%20in%20a%20giant%20mushroom%20trunk%20with%20mysterious%20glowing%20light%20coming%20from%20inside%2C%20fantasy%20forest%20setting%2C%20hand-drawn%20illustration%20style%2C%20magical%20atmosphere%2C%20sparkles%20and%20fireflies%2C%20discovery%20theme%2C%20warm%20mysterious%20lighting&width=600&height=400&seq=featured-article-05&orientation=landscape',
  },
  {
    ...articles[5],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20challenging%20boss%20battle%20scene%20with%20a%20giant%20mushroom%20monster%20facing%20a%20brave%20tiny%20adventurer%2C%20fantasy%20forest%20arena%2C%20hand-drawn%20illustration%20style%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20warm%20and%20vibrant%20colors%2C%20action%20composition&width=600&height=400&seq=featured-article-06&orientation=landscape',
  },
];

export default function FeaturedArticles() {
  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">精选攻略文章</h2>
            <p className="text-sm text-foreground-500">编辑精选的优质攻略，帮你快速提升游戏水平</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredData.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full ${difficultyColors[article.difficulty]}`}>
                  {article.difficulty}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">{article.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>{article.date} · {article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部文章 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}